(() => {
  const ready = (fn) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  };

  ready(() => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const revealItems = document.querySelectorAll('[data-ck-reveal]');
    if (reduceMotion || !('IntersectionObserver' in window)) {
      revealItems.forEach((el) => el.classList.add('is-visible'));
    } else {
      const revealObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });
      revealItems.forEach((el) => revealObserver.observe(el));
    }

    const hero = document.querySelector('[data-ck-hero]');
    const sticky = document.querySelector('[data-ck-sticky-buy]');
    if (hero && sticky && 'IntersectionObserver' in window) {
      const stickyObserver = new IntersectionObserver(([entry]) => {
        sticky.classList.toggle('is-active', !entry.isIntersecting);
      }, { threshold: 0.08 });
      stickyObserver.observe(hero);
      const footer = document.querySelector('footer');
      if (footer) {
        const footerObserver = new IntersectionObserver(([entry]) => {
          if (entry.isIntersecting) sticky.classList.remove('is-active');
        }, { threshold: 0.05 });
        footerObserver.observe(footer);
      }
    }

    document.querySelectorAll('[data-ck-film]').forEach((wrap) => {
      const video = wrap.querySelector('video');
      const toggle = wrap.querySelector('[data-ck-film-toggle]');
      if (!video || !toggle) return;
      const syncLabel = () => {
        toggle.textContent = video.paused ? 'Play' : 'Pause';
        toggle.setAttribute('aria-label', video.paused ? 'Play film' : 'Pause film');
      };
      toggle.addEventListener('click', () => {
        if (video.paused) video.play().catch(() => {}); else video.pause();
        syncLabel();
      });
      video.addEventListener('play', syncLabel);
      video.addEventListener('pause', syncLabel);
      syncLabel();
      if ('IntersectionObserver' in window) {
        const videoObserver = new IntersectionObserver(([entry]) => {
          if (!entry.isIntersecting && !video.paused) video.pause();
          if (entry.isIntersecting && !reduceMotion && video.muted) video.play().catch(() => {});
        }, { threshold: 0.25 });
        videoObserver.observe(video);
      }
    });

    document.querySelectorAll('[data-ck-event]').forEach((el) => {
      el.addEventListener('click', () => {
        const name = el.getAttribute('data-ck-event');
        if (!name) return;
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'ck_storefront_click', ck_action: name, ck_label: (el.textContent || '').trim().slice(0, 80), ck_path: window.location.pathname });
      });
    });
  });
})();